import { MediaType } from "@/modules/common/media/mediaTypes"
import { z } from "zod"

/* 
  MediaDTO is used in: 
    * ScoreboardScoreDto
    * SocialPostDto
    * EventScoreboardScoreDto
  */
export const MediaDtoSchema = z
  .object({
    url: z
      .string()
      .transform((s) => {
        const t = s.trim()
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(t)) return t
        return `https://${t}`
      })
      .pipe(z.httpUrl()),
    key: z.string().nullable(),
    type: z.enum(MediaType),
    filename: z.string().nullable(),
  })
  .meta({ id: "MediaDtoSchema" })

/* 
  MediaInputDto is used in:
    * SetScoreInput
    * SetMultipleScoreInput
    * SetCommentInput
    * SetEventScoreInput
  */
export const MediaInputDtoSchema = z
  .object({
    url: z.url().nullable(),
    key: z.string().nullable(),
    type: z.enum(MediaType),
    filename: z.string().nullable(),
  })
  .meta({ id: "MediaInputDtoSchema" })

export type MediaDto = z.infer<typeof MediaDtoSchema>
export type MediaInputDto = z.infer<typeof MediaInputDtoSchema>
